import styled from 'styled-components'
import { remCalculator } from '../../../helpers/theming/utilities'

const Container = styled.div`
  line-height: ${(props) => props.theme.font['line-height']['body-1']};
  margin: ${(props) => `${remCalculator(props.theme.size.spacing.lg)} 0 ${remCalculator(props.theme.size.spacing.xl)}`};
  width: 100%;
`

export { Container }
